import { React, PropTypes, reduxConnect, styled } from '../lib/imports';
import { SectionTitle, Spacing, Text } from '../components';
import RewardItem from './RewardItem';
import { useCdnUrl } from '../app/context/config';

const PrizeListContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionBg};
`;

const PrizeList = ({ title, blurb, rewards }) => {
  const cdnUrl = useCdnUrl();

  return (
    <PrizeListContainer>
      <Spacing>
        <SectionTitle text={title} shadow size='deca' />
      </Spacing>
      <Spacing sizeLeft='peta' sizeRight='peta' sizeTop='giga' sizeBottom='tera'>
        <Text centered size='tera'>
          {blurb}
        </Text>
      </Spacing>
      {rewards.map(({ id, filename, isLast, ...props }, index) => (
        <Spacing key={index} paddingBottom='byte' sizeLeft='byte' sizeRight='byte'>
          <Spacing sizeLeft='byte' sizeRight='byte' sizeBottom='byte'>
            <RewardItem assetUrl={`${cdnUrl}${filename}`} level={index} {...props} />
          </Spacing>
        </Spacing>
      ))}
    </PrizeListContainer>
  );
};

PrizeList.propTypes = {
  title: PropTypes.string,
  rewards: PropTypes.array,
  lid: PropTypes.string,
  platform: PropTypes.string,
  language: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { strings, prizeList, config } = state;
  const { platform, language } = config;
  const { rewards } = prizeList;

  const allStrings = {
    title: strings['titles/section/prizes/text'],
    blurb: strings['prizes/hockeyChallenge/blurb'],
  };

  const allRewards = rewards.map((reward) => {
    return {
      ...reward,
      filename: strings[`prizes/hockeyChallenge/${reward.id}/image/src`],
      instructionText: strings[`prizes/hockeyChallenge/${reward.id}/title`],
      rewardText: strings[`prizes/hockeyChallenge/${reward.id}/reward`],
      orText: strings['prizes/hockeyChallenge/pointHeader/or'],
      anText: strings['prizes/hockeyChallenge/pointHeader/an'],
      offerText: strings['prizes/hockeyChallenge/pointHeader/offer'],
      pointsText: strings['prizes/hockeyChallenge/pointHeader/points'],
    };
  });

  return {
    ...allStrings,
    rewards: allRewards,
    platform,
    language,
  };
};

export default reduxConnect(mapStateToProps)(PrizeList);
